import React, { ReactElement } from "react";
import styled from "styled-components";

import { PageMeta } from "@shared/seo/page-meta";

export const NotFound: React.FC = (): ReactElement => {
    return (
        <>
            <PageMeta
                title="Страница не найдена — Plumme"
                description="Запрашиваемая страница не найдена."
                path="/not-found"
                noIndex
            />

            <Wrapper>
                <Text>Страница не найдена</Text>
            </Wrapper>
        </>
    );
};

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 100px 0;
`;

const Text = styled.h1`
    font-size: 40px;

    @media (max-width: 768px) {
        font-size: 24px;
    }
`;